import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=eccae8e4"
import script from "./Items.vue?vue&type=script&setup=true&lang=js"
export * from "./Items.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eccae8e4')) {
      api.createRecord('eccae8e4', component.options)
    } else {
      api.reload('eccae8e4', component.options)
    }
    module.hot.accept("./Items.vue?vue&type=template&id=eccae8e4", function () {
      api.rerender('eccae8e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/lists/Items.vue"
export default component.exports